import { Dispatch, SetStateAction, useMemo, useState } from 'react'

import { EventData } from '~/gamification/types/gamification.types'
import { QUIZ_SUBJECT } from '~/types/homebaseQuiz.types'
import { selectEvents } from '~/gamification/slices/gamification.slice'
import { useAppSelector } from '~/redux/hooks'
import { Topic } from '~/types/theory'

export function getParentQuestIdFromUrl(drillUrl: string): QUIZ_SUBJECT | undefined {
  const splittedUrl = drillUrl.split('/')
  const subject = splittedUrl[2]
  switch (subject) {
    case 'gangetabellen':
    case 'the-multiplication-table':
    case 'tablytsya-mnozhennya':
      return QUIZ_SUBJECT.THE_MULTIPLICATION_TABLE
    case 'brok':
    case 'fractions':
    case 'droby':
      return QUIZ_SUBJECT.FRACTIONS
    case 'prosent':
    case 'percent':
    case 'ponyattya-vidsotka':
      return QUIZ_SUBJECT.PERCENT
    case 'bokstavregning':
    case 'basic-algebra':
    case 'osnovy-alhebry':
      return QUIZ_SUBJECT.BASIC_ALGEBRA
    case 'potenser':
    case 'powers':
    case 'stepin-chysla':
      return QUIZ_SUBJECT.POWERS
    case 'parenteser':
    case 'parentheses':
    case 'kruhli-duzhky':
      return QUIZ_SUBJECT.PARENTHESES
    case 'algebraisk-faktorisering':
    case 'algebraic-factorization':
    case 'rozkladannya-mnohochlena-na-mnozhnyky':
      return QUIZ_SUBJECT.FACTORIZATION
    case 'likninger':
    case 'equations':
    case 'rivnyannya':
      return QUIZ_SUBJECT.EQUATIONS
    case 'funksjoner':
    case 'funktsiyi':
    case 'functions':
      return QUIZ_SUBJECT.FUNCTIONS
    default:
      return
  }
}

export function getParentQuestId(topicEntry?: Topic): QUIZ_SUBJECT | undefined {
  if (!topicEntry || !topicEntry.path.includes('/drill/')) {
    return
  }

  return getParentQuestIdFromUrl(topicEntry.path)
}

export default function useGetQuestsForArticle(topic: Topic): {
  isLoading: boolean
  parentQuestId: string | undefined
  setIsLoading: Dispatch<SetStateAction<boolean>>
  parentQuest: EventData | undefined
} {
  const events = useAppSelector(selectEvents)
  const [isLoading, setIsLoading] = useState(false)
  const parentQuestId = getParentQuestId(topic)

  const parentQuest = useMemo(() => {
    return events?.find((event) => {
      return event.id === parentQuestId
    })
  }, [events, parentQuestId])

  return {
    isLoading,
    parentQuestId,
    parentQuest,
    setIsLoading,
  }
}
